import { Directive, HostListener, Input, inject } from '@angular/core';
import { DfEventService } from '@df/core/service/df-event';
import { Gtm } from '@df/module-gtm/event/gtm.event';

/**
 * GTM list directive
 */
@Directive({
    selector: '[gtmPromotionLink]',
    standalone: true
})
export class GtmPromotionLinkDirective {
    @Input({
        required: true
    })
    gtmPromotionLink!: Gtm.Promotion;

    /**
     * Event service
     */
    private dfEventService = inject(DfEventService);

    /**
     * Bind redirects on click
     */
    @HostListener('click')
    dispatchProductClickEvent() {
        this.dfEventService.dispatch({
            id: 'dfGtmPromotionLinkClick',
            data: this.gtmPromotionLink
        });
    }
}
